import { deleteBasket as removeBasket } from 'services/basketsApi';

export const deleteBasket = async (parishId: string, id: string) => {
    return removeBasket(parishId, id);
};
